import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import './index.scss';
import App from './App';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import * as Sentry from '@sentry/browser';
import VConsole from 'vconsole';
import jsbridge from '@xpeng/js-bridge';
import { getClientEnv, getPlatform, getAppVersionFromUserAgent } from './utils/common'
import { ThemeModeProvider } from './ThemeModeContext'
import { themeArray } from '../src/config/index'
let environment = getClientEnv();
const version = 'xp-car-owner-service@' + require('../package.json').version
Sentry.init({
  dsn: "https://cccc27cd76f149d4829d62b0b0e2986c@front-monitor.xiaopeng.com/109",
  environment: environment,
  release: version,
  enabled: process.env.REACT_APP_DELOY_ENV !== 'test'
  // debug: environment === 'dev' || environment === 'test'
});

if (process.env.REACT_APP_DELOY_ENV === 'test' || process.env.REACT_APP_DELOY_ENV === 'deploy') {
  new VConsole();
}

const callHandler_origin = jsbridge.callHandler;
jsbridge.callHandler = (method, params) => {
  console.log(`====== bridge callHandler start =====`)
  console.log(`method: ${method}`);
  console.log('params: ');
  console.log(params);
  Sentry.addBreadcrumb({
    type: 'bridge-callHandler',
    message: `${method} request`,
    data: params,
  });
  return callHandler_origin.call(jsbridge, method, params).then(res => {
    Sentry.addBreadcrumb({
      type: 'bridge-callHandler',
      message: `${method} response`,
      data: res,
    });
    console.log(`method: ${method}`);
    console.log('response: ');
    console.log(res);
    console.log(`====== bridge callHandler end ======`)
    return res;
  }).catch(err => {
    Sentry.captureException(err);
    console.log(`method: ${method}`);
    console.log('error: ');
    console.log(err);
    console.log(`====== bridge callHandler end ======`)
    throw err;
  });
}
// app版本大于4.55.0的支持主题切换
const platform = getPlatform()
const appVersion = getAppVersionFromUserAgent()
const judgeSupportTheme = () => {
  console.log('appVersion', appVersion);
  console.log('platform', platform);
  let returnSupportTheme = false
  const [major, minor, patch] = appVersion
  const validVersion = [5, 1, 0]
  const validPlatform = ['android', 'iOS', 'harmony']
  if (validPlatform.includes(platform)) {
    returnSupportTheme = major > validVersion[0] || 
              (major === validVersion[0] && (minor > validVersion[1] || 
              (minor === validVersion[1] && patch >= validVersion[2])));
  }
  return returnSupportTheme
}
const isSupportTheme = judgeSupportTheme()
const Root = () => {
  useEffect(() => {
    // 在组件挂载后移除 #root 的样式
    const rootElement = document.getElementById('root')
    if (rootElement) {
      rootElement.style.background = ''
    }
  }, [])
  return (
    <React.StrictMode>
      <Router>
        <App />
      </Router>
    </React.StrictMode>
  )
}

const RootSupportTheme = ({ initialMode }) => {
  useEffect(() => {
    // 在组件挂载后移除 #root 的样式
    const rootElement = document.getElementById('root')
    if (rootElement) {
      rootElement.style.background = ''
    }
  }, [])
  return (
    <React.StrictMode>
      <Router>
        <ThemeModeProvider initialMode={initialMode}>
          <App />
        </ThemeModeProvider>
      </Router>
    </React.StrictMode>
  )
}

const renderApp = (isSupportTheme: boolean, initialMode?: string) => {
  isSupportTheme ? ReactDOM.render(<RootSupportTheme initialMode={initialMode} />, document.getElementById('root')) :
    ReactDOM.render(<Root />, document.getElementById('root'))
}

if (isSupportTheme) {
  try {
    jsbridge.callHandler('getThemeMode', {})
      .then((res) => {
        if (themeArray.includes(res.data.mode)) {
          // 判断是不是mona-ota页面 如果是直接设置为白色
          if (window.location.href.includes('mona_ota')) {
            document.documentElement.setAttribute('data-theme', 'light')
          } else {
            document.documentElement.setAttribute('data-theme', res.data.mode)
          }
          renderApp(true, res.data.mode)
        } else {
          renderApp(false)
        }
      })
  } catch (error) {
    renderApp(false)
  }
} else {
  renderApp(false)
}